import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Badge } from '../badge';
import translationFallback from '../i18n/translations/en-US/waffles.json';
import { ScreenReaderOnly } from '../screen-reader-only';
import { countStyle } from './styles';
function Counter({ count, mode, size, variant }) {
    const { ready, t } = useTranslation('waffles');
    return (_jsxs(Badge, Object.assign({ css: countStyle({ size }), "data-testid": "button-counter" }, { mode, size, variant }, { children: [_jsxs(ScreenReaderOnly, { children: [ready ? t('Counter.label') : translationFallback.Counter.label, ': '] }), count] })));
}
export default Counter;
